import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import { ICampaignLog } from "@/interfaces/campaign-logs.interface";
import { CampaignLogsMessages } from "@/messages/campaigns/logs/campaign-logs.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { CampaignLogTableRow } from "./row";
import { CAMPAIGN_LOGS_TABLE_COLUMNS } from "../../constants";

interface Props {
  data: PaginatedResponse<ICampaignLog>;
  pagination: Pagination;
  messages: CampaignLogsMessages;
}

export function CampaignLogTable({ data, pagination, messages }: Props) {
  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {CAMPAIGN_LOGS_TABLE_COLUMNS(messages).map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>

          <TableBody>
            {data.items.map((log, index) => (
              <CampaignLogTableRow
                key={`${index} - ${log.id}`}
                log={log}
                index={index}
                messages={messages}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
        rowsPerPage={pagination.pageSize}
        page={pagination.pageNumber - 1}
        onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
      />
    </>
  );
}
